export function NotFoundPage() {
  return (
    <main className="min-h-screen flex items-center justify-center bg-surface-base">
      <div className="text-center">
        <h1 className="text-4xl font-semibold">404</h1>
        <p className="mt-2 text-text-secondary">Page not found.</p>
      </div>
    </main>
  );
}
